@if ({ returnUrl: returnUrl$ | async,
       userDoesNotExist: userDoesNotExist$ | async,
       isSignInError: isSignInError$ | async }; as data) {
  <div [ngClass]="{ 'signin-page': !isModalOpened, 'signin-page--modal': isModalOpened }">
    <div [ngClass]="{ 'signin-card': !isModalOpened, 'signin-card--modal': isModalOpened }">
      @if (!isModalOpened) {
        <p-tabs class="auth-tabs" [showNavigators]="false" [value]="signInTab" (valueChange)="onTabChange($event)">
          <p-tablist>
            <p-tab [value]="signInTab">{{ 'label.SignIn' | translate }}</p-tab>
            <p-tab [value]="registrationTab">{{ 'label.Registration' | translate }}</p-tab>
          </p-tablist>
        </p-tabs>
      }

      <div class="signin-card__body">
        <app-spinner [isLoading]="isLoading$ | async" [isFixedPosition]="false">
          @if (!isModalOpened) {
            <h1 class="signin-heading">{{ 'label.SignIn' | translate }}</h1>
            <p class="signin-subheading">{{ 'label.ForJobseeker' | translate }}</p>
          }

          <form class="signin-form" [formGroup]="submitForm">
            <div class="auth-field">
              <hrra-floating-field>
                <input pInputText id="signin-email" type="email" autocomplete="email" formControlName="emailInput" />
                <label for="signin-email">{{ 'label.Email' | translate }}</label>
              </hrra-floating-field>
            </div>

            <div class="auth-field">
              <hrra-floating-field>
                <input
                  pInputText
                  id="signin-password"
                  class="auth-field__password"
                  [type]="isPasswordVisible ? 'text' : 'password'"
                  autocomplete="current-password"
                  formControlName="passwordInput" />
                <label for="signin-password">{{ 'label.Password' | translate }}</label>
                @if (submitForm.controls['passwordInput'].value) {
                  <button type="button" class="auth-field__password-toggle" (click)="isPasswordVisible = !isPasswordVisible">
                    <svg-icon [src]="isPasswordVisible ? '/assets/icons/password-unhide.svg' : '/assets/icons/password-hide.svg'"></svg-icon>
                  </button>
                }
              </hrra-floating-field>
            </div>

            <div class="signin-remember">
              <input id="signin-remember" class="auth-checkbox" type="checkbox" formControlName="staySignedInCheckbox" />
              <label class="signin-remember__label" for="signin-remember">{{ 'label.KeepMeSignedIn' | translate }}</label>
            </div>

            <a class="signin-recovery" [routerLink]="['/jobseeker/reset-password']">{{ 'label.ForgotThePassword' | translate }}</a>

            <button class="signin-submit" type="submit" (click)="onLoginClick(data.returnUrl)">
              {{ 'label.SignIn' | translate }}
            </button>
          </form>

          @if (data.isSignInError || data.userDoesNotExist) {
            <div class="signin-error">
              <app-jobseeker-error-message
                [messageHeading]="'label.LoginFailed' | translate"
                [message]="'label.LoginFailedMessage' | translate"></app-jobseeker-error-message>
            </div>
          }
        </app-spinner>

        @if (!isModalOpened) {
          <div class="auth-switch">
            <span class="auth-switch__text">{{ 'label.DontHaveAnaccount' | translate }}</span>
            <a class="auth-switch__link" [routerLink]="['/jobseeker/register']">{{ 'label.CvRegistration' | translate }}</a>
          </div>
        }
      </div>
    </div>

    @if (!isModalOpened) {
      <app-jobseeker-recruitment-box class="signin-recruitment"></app-jobseeker-recruitment-box>
    }
  </div>
}
